import React, {useCallback, useEffect, useState} from 'react';
import {userApi} from "../../../../redux/user/user-api";
import {connect} from "react-redux";
import userPlaceholder from "../../../../images/user-placeholder.png";
import userCheck from "../../../../images/user-check.svg";
import {useTranslation} from "react-i18next";


const TeamMember = ({user, isHideCheck}) => {
  const [avatar, setAvatar] = useState(null)
  const {t} = useTranslation()
  const fetchFileInfo = useCallback(async (id) => {
    const response = await userApi.getFile(id)
    setAvatar(response !== null ? Buffer.from(response.data, 'binary').toString('base64') : null)
  }, [])
  useEffect(() => {
    if (user.image_link) {
      fetchFileInfo(user.image_link)
    }
  }, [])
  return (
    <div className={'modal__member modal__friend'}>
      <div className={'member__common'}>
        <div className="modal__imgWrapper">
          {(user.accepted && !isHideCheck) && <img src={userCheck} className={'modal__friendCheck'} alt=""/>}
          {user.accepted ? <img className={'member__avatar'} src={(avatar) ? `data:image/png;base64,${avatar}` : userPlaceholder}
                alt=""/> : <div className={'member__placeholderAvatar'} />}
        </div>
        <div className="member__info">
          {(user.accepted && (user.first_name || user.last_name)) && <p className="member__name">
            {`${user.first_name ?? ''} ${user.last_name ?? ''}`}
          </p>}
          <p className="member__email">
            {user.accepted ?
              user.email : user.email.replace(user.email.split('@')[0].substring(2, user.email.split('@')[0].length),
                '*'.repeat(user.email.split('@')[0].length - 2))}
          </p>
        </div>
      </div>
      <p className="member__role">
        {user.accepted && user.role?.name}
      </p>
    </div>
  );
};


export default TeamMember
